// src/components/NPS.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './NPS.module.scss';

const NPS = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [ruc, setRuc] = useState('');
  const [score, setScore] = useState(null);
  const [feedback, setFeedback] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleNext = () => {
    if (step === 1) {
      if (!name.trim() || !email.trim() || !phone.trim() || !ruc.trim()) {
        alert('Por favor completa todos los campos obligatorios.');
        return;
      }
    }
    if (step === 2) {
      if (score === null) {
        alert('Por favor selecciona una puntuación.');
        return;
      }
    }
    setStep(step + 1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Fake API call
    setTimeout(() => {
      setIsSubmitting(false);
      setShowModal(true);
    }, 1500);
  };

  const closeModal = () => {
    setShowModal(false);
    navigate('/');
  };

  const percent = Math.round((step / 3) * 100);

  return (
    <>
      <div className={styles.card}>
        <div className={styles.progressBar}>
          <div className={styles.progress} style={{ width: `${percent}%` }} />
        </div>

        {step === 1 && (
          <>
            <h2 className={styles.title}>
              Encuesta de Satisfacción con Zoomlion Latinoamérica
            </h2>
            <div className={styles.fieldGroup}>
              <label htmlFor="name">Nombre completo *</label>
              <input
                id="name"
                type="text"
                value={name}
                onChange={e => setName(e.target.value)}
                className={styles.input}
              />
            </div>
            <div className={styles.fieldGroup}>
              <label htmlFor="email">Correo electrónico *</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                className={styles.input}
              />
            </div>
            <div className={styles.fieldGroup}>
              <label htmlFor="phone">Teléfono *</label>
              <input
                id="phone"
                type="tel"
                value={phone}
                onChange={e => setPhone(e.target.value)}
                className={styles.input}
              />
            </div>
            <div className={styles.fieldGroup}>
              <label htmlFor="ruc">RUC *</label>
              <input
                id="ruc"
                type="text"
                value={ruc}
                onChange={e => setRuc(e.target.value)}
                className={styles.input}
              />
            </div>
            <button
              type="button"
              className={styles.submitBtn}
              onClick={handleNext}
            >
              Continuar
            </button>
          </>
        )}

        {step === 2 && (
          <>
            <h2 className={styles.title}>
              En una escala del 0 al 10, ¿qué probabilidad hay de que recomiende Zoomlion Perú a un amigo o colega?
            </h2>
            <div className={styles.scale}>
              {Array.from({ length: 11 }, (_, i) => (
                <button
                  key={i}
                  type="button"
                  className={`${styles.scoreBtn} ${score === i ? styles.active : ''}`}
                  onClick={() => setScore(i)}
                >
                  {i}
                </button>
              ))}
            </div>
            <button
              type="button"
              className={styles.submitBtn}
              onClick={handleNext}
            >
              Continuar
            </button>
          </>
        )}

        {step === 3 && (
          <form onSubmit={handleSubmit}>
            <h2 className={styles.title}>
              ¿Cuál es la razón principal de su puntuación? (opcional)
            </h2>
            <div className={styles.fieldGroup}>
              <textarea
                id="feedback"
                value={feedback}
                onChange={e => setFeedback(e.target.value)}
                className={styles.textarea}
                placeholder="Razón principal (opcional)"
              />
            </div>
            <button
              type="submit"
              className={styles.submitBtn}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Enviando...' : 'Enviar'}
            </button>
          </form>
        )}
      </div>

      {showModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal}>
            <h3>¡Gracias por tu participación, {name}!</h3>
            <button className={styles.closeBtn} onClick={closeModal}>
              Cerrar
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default NPS;
